<template>
  <base-material-card>
    <h4 class="title font-weight-light">
      Set Daily Usage (gal.)
    </h4>
    <v-container>
      <v-row>
        <v-col>
          <v-text-field
            type="number"
            v-model="globalDailyValue"
            label="Per Day"
            @input="setDailyValues"
            @keydown.native.enter.prevent
            :disabled="readOnly"
          />
        </v-col>
      </v-row>
    </v-container>
    <v-container><p>or</p></v-container>
    <v-container>
      <v-row>
        <v-col v-for="(dailyValue, i) in usage" :key="`dailyValue-${i}`">
          <v-text-field
            v-model="usage[i]"
            type="number"
            @keydown.native.enter.prevent
            :label="dailyValueKeys[i]"
            @input="clearGlobalDailyValue"
            :disabled="readOnly"
          />
        </v-col>
      </v-row>
    </v-container>
  </base-material-card>
</template>

<script>
export default {
  props: {
    usage: {
      type: Array,
      default() {
        return [0, 0, 0, 0, 0, 0, 0];
      },
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      globalDailyValue: null,
      dailyValueKeys: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ],
    };
  },
  methods: {
    setDailyValues(value) {
      this.usage.forEach((day, index) => {
        this.usage[index] = value;
      });
    },
    clearGlobalDailyValue() {
      this.globalDailyValue = null;
    },
  },
};
</script>
